import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption } from '../../../../shared/models/select-option';

@Pipe({
  name: 'applicationTypeLabel',
  standalone: true,
})
export class ApplicationTypeLabelPipe implements PipeTransform {
  transform(code: string, applicationTypes: SelectOption<string>[]): string {
    if (code === 'ALL') {
      return 'Wszystkie';
    }

    return applicationTypes.find((el) => el.value === code)?.label ?? code;
  }
}
